<template>
  <div id="container">
    <i id="selectfiles" class="icon uploader-icon"> </i>
  </div>
</template>

<style scoped lang="less">
  @import "../assets/base";

  .uploader-icon {
    padding: 10px;
    height: 30px;
    line-height: 32px;
  }

  .uploader-icon:before {
    content: '\e63d';
    font-size: 16px;
    width: 16px;
    height: 16px;
    line-height: 16px;
    cursor: pointer;
    color: @darkGray;
  }
</style>

<script>
  export default{
    data(){
      return{
        msg:'hello vue',
        serverPath: "http://media.daily.taobao.net/upload/uploadPicture.htm",
        accessid: 'LTAIkLyfZl7jnHqY',
        accesskey: '6zZIVTCpqw3UF5MFNLMn4C7CC7wrhJ',
        host: 'http://delibird-repo.oss-cn-hangzhou.aliyuncs.com',
        g_dirname: 'cncare_tb/',
        g_object_name: '',
        g_object_name_type: '',
        new_multipart_params: '',
        now: Date.parse(new Date()) / 1000,
        timestamp: this.now,
        policyText :'',
        policyBase64: '',
        message: '',
        bytes: '',
        signature: '',
        filename:'',
        imageUrl:'https://delibirdc.i56.taobao.com/download.htm?key=',
        fileKey:'',
      }
    },
    ready() {
      var me = this;

      me.policyText = {
        "expiration": "2020-01-01T12:00:00.000Z", //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
        "conditions": [
          ["content-length-range", 0, 1048576000] // 设置上传文件的大小限制
        ]
      };

      me.policyBase64 = Base64.encode(JSON.stringify(me.policyText));
      me.message = me.policyBase64;
      me.bytes = Crypto.HMAC(Crypto.SHA1, me.message, me.accesskey, { asBytes: true }) ;
      me.signature = Crypto.util.bytesToBase64(me.bytes);

      var uploader = new plupload.Uploader({
        runtimes : 'html5,flash,silverlight,html4',
        browse_button : 'selectfiles',
        //multi_selection: false,
        container: document.getElementById('container'),
        flash_swf_url : 'lib/plupload-2.3.6/js/Moxie.swf',
        silverlight_xap_url : 'lib/plupload-2.3.6/js/Moxie.xap',
        url : 'http://oss.aliyuncs.com',
        http_method:'PUT',
        headers:{'Content-Type':'application/octet-stream'},
        multipart:false,

        init: {
          PostInit: function() {
          },


          FilesAdded: function(up, files) {
            me.set_upload_param(up, '', false);
          },

          BeforeUpload: function(up, file) {
            me.g_object_name_type = 'local_name';
            me.filename=me.g_dirname+me.generateUUID()+file.name;
        //    me.set_upload_param(up, me.filename, true);
          },

          FileUploaded: function(up, file, info) {
            if (info.status == 200)
            {
              var url = me.imageUrl  + me.fileKey;
              me.$dispatch('user-message', {message: url, source: 'userImg'});
            }
            else
            {
//              document.getElementById(file.id).getElementsByTagName('b')[0].innerHTML = info.response;
            }
          },

          Error: function(up, err) {
            document.getElementById('console').appendChild(document.createTextNode("\nError xml:" + err.response));
          }
        }
      });

      uploader.init();
    },
    methods: {
      generateUUID() {
        var d = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (d + Math.random()*16)%16 | 0;
        d = Math.floor(d/16);
        return (c=='x' ? r : (r&0x3|0x8)).toString(16);
        });
       return uuid;
      },
      set_upload_param(up, filename, ret) {
        var me = this;

        var promise=lib.mtop.request({
            api: 'mtop.cainiao.delibird.clientmux.filestore.getuploadinfo',
            v: '1.0',
            });
        promise.then(function(resJson) {
          if(resJson && resJson.data && resJson.data.data && resJson.data.data.features){
              var features = resJson.data.data.features;
              me.fileKey = features.key;
              up.setOption({
               'url': features.url,
              });

             up.start();
          }

        }, function () {
           console.log('上传失败');
        });

        /*
        me.new_multipart_params = {
          'key' : filename,
          'policy': me.policyBase64,
          'OSSAccessKeyId': me.accessid,
          'success_action_status' : '200', //让服务端返回200,不然，默认会返回204
          'signature': me.signature

          ,
        };

        up.setOption({
          'url': me.host,
          'multipart_params': me.new_multipart_params
        });

        up.start();*/
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UploaderPlugin.vue?35b59e40